var NAMESPACE = 'td';

var Badge = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-badge", class: { 'td-badge--dot': _vm.isDot } }, [_vm._t("default"), _vm._v(" "), !_vm.hideSup ? _c('sup', { staticClass: "td-badge__content", domProps: { "textContent": _vm._s(_vm.content) } }) : _vm._e()], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-badge',
  props: {
    value: [String, Number],
    max: Number,
    isDot: Boolean,
    hideSup: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    content: function content() {
      if (this.isDot) return;

      var value = this.value;
      var max = this.max;

      if (typeof value === 'number' && typeof max === 'number') {
        return max < value ? max + '+' : value;
      }

      return value;
    }
  }
};

Badge.install = function (Vue) {
  Vue.component(Badge.name, Badge);
};

export default Badge;
